namespace Matrix.Visualizer {
    export class GraphInstanceColumns {
        static columnsKey = 'Visualizer.GraphInstance';
    }
}
